import { useQuery } from "urql";

import {
  DashboardNextPaymentDueDocument,
  QueryDashboardNextPaymentDueArgs,
} from "../../../graphql/generated.ts";

export const useDashboardNextPaymentDue = (
  variables: QueryDashboardNextPaymentDueArgs
) => {
  return useQuery({
    query: DashboardNextPaymentDueDocument,
    variables,
  });
};
